export const NavigationRoutes = {
    LOGIN: '/login',
    HEADERSETTINGS: '/content-settings',
    DASHBOARD: '/dashboard',
    MARKETPLACE_PULSE: '/marketplace-pulse',
    VIEWS_TREND: '/views-trend',
    ADVERTISER_MAP: '/advertiser-map',
    AUDIT_LOGS: '/audit-logs',
    ABOUT_US: '/about-us',
    CAR_REVIEW: '/car-review',
    VERIFIED_USER_LISTING: '/verified-user-listing',
    DEALER_LISTING: '/dealers',
    ACTIVE_ADMIN: '/active-admin',

    CATEGORIES: '/categories',
    SUB_CATEGORIES: '/categories/:id',
    ATTRIBUTES: '/attributes/:id',
    FORGOT_PASSWORD: '/forgot-password',
    ADMIN_DASHBOARD: '/admin-dashboard',
    DEALER_DASHBOARD: '/dealer-dashboard',
    PENDING_DEALERS: '/pending-dealers',

    CREATE_NEW_PASSWORD: "/create-new-password/:token",
    USER_DETAILS: "/user-details/:id",
    PLANS: '/plans',
    AD_PRICING: '/ad-pricing',
    AD_FEATURES: '/ad-features',
    TIERS: '/tiers',

    BANKS: '/banks',
    SOLD_ADS: '/sold-ads',
    BILLING: '/billing',
    DISCOUNT_CODES: '/discount-codes',
    REMOVED_EXPIRED_ADS: '/removed-expired-ads',

    VEHICLE: '/vehicle',
    SUSPISIOUS: '/suspicious-activity',
    MESSAGES: '/messages',
    FINANCE: '/finance',

    VEHICLE_MAKE: '/vehicle-make',
    VEHICLE_MODEL: '/vehicle-make/:make_name/:parent_name',
    BLOG: '/blog',
    ADD_BLOG: '/add-blog',
    GDPR: '/gdpr',
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_AND_CONDIIONS: '/terms-and-conditions',
    PAYMENT_OPTION: '/payment-option',

    EDIT_BLOG: '/add-blog/:id',
    FAQS: '/faqs',
    CONTACTUS: '/contact',
    ADREPORTS: '/ad-reports',
    FILTER_MANAGEMENT: '/filter-management',


};